import React from 'react';
import { useTranslation } from 'react-i18next';

import PolicyNavigation from './PolicyNavigation';

interface TermsOfServiceContentProps {
  onNavigate?: (view: string) => void;
}

const TermsOfServiceContent: React.FC<TermsOfServiceContentProps> = ({ onNavigate }) => {
  const { t } = useTranslation();
  return (
    <div className="max-w-4xl mx-auto vscode-text-primary pt-8">
      <h1 className="text-3xl font-bold mb-6 vscode-text-primary">{t('legal.termsTitle')}</h1>
      
      <div className="prose max-w-none">
        <p className="text-sm vscode-text-secondary mb-6">
          <strong>{t('legal.terms.effectiveDate')}:</strong> {t('legal.terms.effectiveDateValue')}<br />
          <strong>{t('legal.terms.lastUpdated')}:</strong> {t('legal.terms.lastUpdatedValue')}
        </p>

        <p className="text-lg vscode-text-secondary mb-6">{t('legal.terms.intro')}</p>

        <div className="mb-8 p-4  ">
          <p className="vscode-text-secondary"><strong>{t('legal.terms.important')}</strong></p>
        </div>

        <div className="mb-8 p-4  ">
          <p className="vscode-text-secondary"><strong>{t('legal.terms.noteEmployers')}</strong></p>
        </div>

        {/* Section 1 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s1Title')}</h2>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s1Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s1_1')}</li>
          <li>{t('legal.terms.s1_2')}</li>
          <li>{t('legal.terms.s1_3')}</li>
          <li>{t('legal.terms.s1_4')}</li>
        </ul>

        {/* Section 2 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s2Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s2_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s2_1Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s2_1_1')}</li>
          <li>{t('legal.terms.s2_1_2')}</li>
          <li>{t('legal.terms.s2_1_3')}</li>
          <li>{t('legal.terms.s2_1_4')}</li>
          <li>{t('legal.terms.s2_1_5')}</li>
          <li>{t('legal.terms.s2_1_6')}</li>
          <li>{t('legal.terms.s2_1_7')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s2_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s2_2Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s2_2_1')}</li>
          <li>{t('legal.terms.s2_2_2')}</li>
          <li>{t('legal.terms.s2_2_3')}</li>
          <li>{t('legal.terms.s2_2_4')}</li>
          <li>{t('legal.terms.s2_2_5')}</li>
          <li>{t('legal.terms.s2_2_6')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s2_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s2_3Intro')}</p>

        {/* Section 3 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s3Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s3_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s3_1Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s3_1_1')}</li>
          <li>{t('legal.terms.s3_1_2')}</li>
          <li>{t('legal.terms.s3_1_3')}</li>
          <li>{t('legal.terms.s3_1_4')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s3_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s3_2Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s3_2_1')}</li>
          <li>{t('legal.terms.s3_2_2')}</li>
          <li>{t('legal.terms.s3_2_3')}</li>
          <li>{t('legal.terms.s3_2_4')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s3_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s3_3Intro')}</p>

        {/* Section 4 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s4Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s4_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s4_1Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s4_1_1')}</li>
          <li>{t('legal.terms.s4_1_2')}</li>
          <li>{t('legal.terms.s4_1_3')}</li>
          <li>{t('legal.terms.s4_1_4')}</li>
          <li>{t('legal.terms.s4_1_5')}</li>
          <li>{t('legal.terms.s4_1_6')}</li>
          <li>{t('legal.terms.s4_1_7')}</li>
          <li>{t('legal.terms.s4_1_8')}</li>
          <li>{t('legal.terms.s4_1_9')}</li>
          <li>{t('legal.terms.s4_1_10')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s4_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s4_2Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s4_2_1')}</li>
          <li>{t('legal.terms.s4_2_2')}</li>
          <li>{t('legal.terms.s4_2_3')}</li>
          <li>{t('legal.terms.s4_2_4')}</li>
          <li>{t('legal.terms.s4_2_5')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s4_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s4_3Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s4_3_1')}</li>
          <li>{t('legal.terms.s4_3_2')}</li>
          <li>{t('legal.terms.s4_3_3')}</li>
          <li>{t('legal.terms.s4_3_4')}</li>
          <li>{t('legal.terms.s4_3_5')}</li>
          <li>{t('legal.terms.s4_3_6')}</li>
          <li>{t('legal.terms.s4_3_7')}</li>
          <li>{t('legal.terms.s4_3_8')}</li>
        </ul>

        {/* Section 5 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s5Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s5_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s5_1Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s5_1_1')}</li>
          <li>{t('legal.terms.s5_1_2')}</li>
          <li>{t('legal.terms.s5_1_3')}</li>
        </ul>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s5_1_4')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s5_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s5_2Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s5_2_1')}</li>
          <li>{t('legal.terms.s5_2_2')}</li>
          <li>{t('legal.terms.s5_2_3')}</li>
          <li>{t('legal.terms.s5_2_4')}</li>
          <li>{t('legal.terms.s5_2_5')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s5_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s5_3Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s5_3_1')}</li>
          <li>{t('legal.terms.s5_3_2')}</li>
          <li>{t('legal.terms.s5_3_3')}</li>
          <li>{t('legal.terms.s5_3_4')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s5_4Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s5_4Intro')}</p>

        {/* Section 6 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s6Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s6_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s6_1Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s6_1_1')}</li>
          <li>{t('legal.terms.s6_1_2')}</li>
          <li>{t('legal.terms.s6_1_3')}</li>
          <li>{t('legal.terms.s6_1_4')}</li>
        </ul>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s6_1_5')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s6_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s6_2Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s6_2_1')}</li>
          <li>{t('legal.terms.s6_2_2')}</li>
          <li>{t('legal.terms.s6_2_3')}</li>
          <li>{t('legal.terms.s6_2_4')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s6_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s6_3Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s6_3_1')}</li>
          <li>{t('legal.terms.s6_3_2')}</li>
          <li>{t('legal.terms.s6_3_3')}</li>
          <li>{t('legal.terms.s6_3_4')}</li>
        </ul>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s6_3_5')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s6_4Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s6_4Intro')}</p>

        {/* Section 7 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s7Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s7_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s7_1Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s7_1_1')}</li>
          <li>{t('legal.terms.s7_1_2')}</li>
          <li>{t('legal.terms.s7_1_3')}</li>
          <li>{t('legal.terms.s7_1_4')}</li>
          <li>{t('legal.terms.s7_1_5')}</li>
          <li>{t('legal.terms.s7_1_6')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s7_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s7_2Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s7_2_1')}</li>
          <li>{t('legal.terms.s7_2_2')}</li>
          <li>{t('legal.terms.s7_2_3')}</li>
          <li>{t('legal.terms.s7_2_4')}</li>
          <li>{t('legal.terms.s7_2_5')}</li>
          <li>{t('legal.terms.s7_2_6')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s7_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s7_3Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s7_3_1')}</li>
          <li>{t('legal.terms.s7_3_2')}</li>
          <li>{t('legal.terms.s7_3_3')}</li>
          <li>{t('legal.terms.s7_3_4')}</li>
          <li>{t('legal.terms.s7_3_5')}</li>
          <li>{t('legal.terms.s7_3_6')}</li>
          <li>{t('legal.terms.s7_3_7')}</li>
          <li>{t('legal.terms.s7_3_8')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s7_4Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s7_4Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s7_4_1')}</li>
          <li>{t('legal.terms.s7_4_2')}</li>
          <li>{t('legal.terms.s7_4_3')}</li>
          <li>{t('legal.terms.s7_4_4')}</li>
        </ul>

        <div className="mt-6 p-4  ">
          <p className="vscode-text-secondary">{t('legal.terms.s7_4Warning')}</p>
        </div>

        {/* Section 8 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s8Title')}</h2>
        <p className="vscode-text-secondary mb-4">
          {t('legal.terms.s8Intro')}
          <a href="/privacy-policy" className="text-[var(--vscode-text-link)] hover:opacity-90"> {t('legal.terms.s8PrivacyLink')}</a>{t('legal.terms.s8Incorporated')}
        </p>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s8Consent')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s8_1')}</li>
          <li>{t('legal.terms.s8_2')}</li>
          <li>{t('legal.terms.s8_3')}</li>
          <li>{t('legal.terms.s8_4')}</li>
          <li>{t('legal.terms.s8_5')}</li>
        </ul>

        {/* Section 9 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s9Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s9_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s9_1Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s9_1_1')}</li>
          <li>{t('legal.terms.s9_1_2')}</li>
          <li>{t('legal.terms.s9_1_3')}</li>
          <li>{t('legal.terms.s9_1_4')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s9_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s9_2Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s9_2_1')}</li>
          <li>{t('legal.terms.s9_2_2')}</li>
          <li>{t('legal.terms.s9_2_3')}</li>
          <li>{t('legal.terms.s9_2_4')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s9_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s9_3Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s9_3_1')}</li>
          <li>{t('legal.terms.s9_3_2')}</li>
          <li>{t('legal.terms.s9_3_3')}</li>
          <li>{t('legal.terms.s9_3_4')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s9_4Title')}</h3>
        <div className="p-4 bg-red-900/20 border-l-4 border-red-500 mb-4">
          <p className="vscode-text-secondary mb-2"><strong>{t('legal.terms.s9_4Label')}</strong></p>
          <p className="vscode-text-secondary">{t('legal.terms.s9_4Cap')}</p>
        </div>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s9_4Max')}</p>

        {/* Section 10 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s10Title')}</h2>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s10Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s10_1')}</li>
          <li>{t('legal.terms.s10_2')}</li>
          <li>{t('legal.terms.s10_3')}</li>
          <li>{t('legal.terms.s10_4')}</li>
          <li>{t('legal.terms.s10_5')}</li>
          <li>{t('legal.terms.s10_6')}</li>
        </ul>

        {/* Section 11 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s11Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s11_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">
          {t('legal.terms.s11_1Intro')} <a href="mailto:support@gograbjob.com" className="text-[var(--vscode-text-link)] hover:opacity-90">support@gograbjob.com</a> {t('legal.terms.s11_1At')}
        </p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s11_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s11_2Intro')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s11_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s11_3Intro')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s11_4Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s11_4Intro')}</p>

        {/* Section 12 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s12Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s12_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s12_1Intro')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s12_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s12_2Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s12_2_1')}</li>
          <li>{t('legal.terms.s12_2_2')}</li>
          <li>{t('legal.terms.s12_2_3')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s12_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s12_3Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s12_3_1')}</li>
          <li>{t('legal.terms.s12_3_2')}</li>
          <li>{t('legal.terms.s12_3_3')}</li>
          <li>{t('legal.terms.s12_3_4')}</li>
          <li>{t('legal.terms.s12_3_5')}</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s12_4Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s12_4Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s12_4_1')}</li>
          <li>{t('legal.terms.s12_4_2')}</li>
          <li>{t('legal.terms.s12_4_3')}</li>
          <li>{t('legal.terms.s12_4_4')}</li>
        </ul>

        {/* Section 13 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s13Title')}</h2>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s13Intro')}</p>
        <ul className="list-disc list-inside vscode-text-secondary mb-4 space-y-2 ml-4">
          <li>{t('legal.terms.s13_1')}</li>
          <li>{t('legal.terms.s13_2')}</li>
          <li>{t('legal.terms.s13_3')}</li>
          <li>{t('legal.terms.s13_4')}</li>
        </ul>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s13_5')}</p>

        {/* Section 14 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s14Title')}</h2>
        
        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s14_1Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s14_1Intro')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s14_2Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s14_2Intro')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s14_3Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s14_3Intro')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s14_4Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s14_4Intro')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s14_5Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s14_5Intro')}</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">{t('legal.terms.s14_6Title')}</h3>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s14_6Intro')}</p>

        {/* Section 15 */}
        <h2 className="text-2xl font-semibold mt-8 mb-4">{t('legal.terms.s15Title')}</h2>
        <p className="vscode-text-secondary mb-4">{t('legal.terms.s15Intro')}</p>
        <div className=" p-6-lg mb-4">
          <p className="vscode-text-secondary mb-2"><strong>{t('legal.terms.s15LegalTeam')}</strong></p>
          <p className="vscode-text-secondary mb-2">
            {t('legal.terms.s15Email')} <a href="mailto:support@gograbjob.com" className="text-[var(--vscode-text-link)] hover:opacity-90">support@gograbjob.com</a>
          </p>
          <p className="vscode-text-secondary mb-2">
            {t('legal.terms.s15Support')} <a href="mailto:support@gograbjob.com" className="text-[var(--vscode-text-link)] hover:opacity-90">support@gograbjob.com</a>
          </p>
          <p className="vscode-text-secondary">
            {t('legal.terms.s15Website')} <a href="https://www.gograbjob.com" className="text-[var(--vscode-text-link)] hover:opacity-90">www.gograbjob.com</a>
          </p>
        </div>

        {/* Acknowledgment */}
        <div className="mt-8 p-6 bg-green-900/20 ">
          <p className="vscode-text-secondary">
            <strong>{t('legal.terms.ackTitle')}</strong> {t('legal.terms.ackBody')}
          </p>
        </div>

        {/* Quick Links */}
        <div className="mt-8 p-4 -lg">
          <p className="text-sm vscode-text-secondary mb-2"><strong>{t('legal.terms.relatedTitle')}</strong></p>
          <ul className="text-sm vscode-text-secondary space-y-1">
            <li>• <a href="/privacy-policy" className="text-[var(--vscode-text-link)] hover:opacity-90">{t('legal.terms.privacyLink')}</a></li>
            <li>• <a href="/cookie-policy" className="text-[var(--vscode-text-link)] hover:opacity-90">{t('legal.terms.cookieLink')}</a></li>
            <li>• <a href="/gdpr-compliance" className="text-[var(--vscode-text-link)] hover:opacity-90">{t('legal.terms.gdprLink')}</a></li>
          </ul>
        </div>
      </div>

      {/* Related Policies Navigation */}
      <PolicyNavigation currentPolicy="terms" onNavigate={onNavigate} />
    </div>
  );
};

export default TermsOfServiceContent;
